import { useState } from 'react';
import { FormField, FormLabel, FormSelect, Button } from '../ui';
import { FallbackRequestFilters as FallbackFiltersType } from '../../types/fallback';
import { Search, X } from 'lucide-react';

interface FallbackRequestFiltersProps {
  filters: FallbackFiltersType;
  onFilterChange: (filters: FallbackFiltersType) => void;
  onResetFilters: () => void;
  assistants: any[];
  whatsappSessions: any[];
}

function FallbackRequestFilters({
  filters,
  onFilterChange,
  onResetFilters,
  assistants,
  whatsappSessions,
}: FallbackRequestFiltersProps) {
  const [localFilters, setLocalFilters] = useState<FallbackFiltersType>({
    ...filters,
  });

  const handleLocalFilterChange = (name: string, value: string) => {
    setLocalFilters(prev => ({
      ...prev,
      [name]: value || undefined,
    }));
  };

  const handleApplyFilters = () => {
    onFilterChange({
      ...localFilters,
      page: 1, // Reset to first page when filters change
    });
  };

  const hasActiveFilters = Object.keys(filters).some(
    key => key !== 'page' && key !== 'limit' && filters[key as keyof FallbackFiltersType]
  );

  return (
    <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow mb-6">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <FormField>
          <FormLabel htmlFor="status">Status</FormLabel>
          <FormSelect
            id="status"
            name="status"
            value={localFilters.status || ''}
            onChange={e => handleLocalFilterChange('status', e.target.value)}
          >
            <option value="">Todos</option>
            <option value="pending">Pendente</option>
            <option value="awaiting_finalization">Aguardando</option>
            <option value="completed">Concluído</option>
          </FormSelect>
        </FormField>

        <FormField>
          <FormLabel htmlFor="assistant_id">Assistente</FormLabel>
          <FormSelect
            id="assistant_id"
            name="assistant_id"
            value={localFilters.assistant_id?.toString() || ''}
            onChange={e => handleLocalFilterChange('assistant_id', e.target.value)}
          >
            <option value="">Todos</option>
            {assistants.map(assistant => (
              <option key={assistant.id} value={assistant.id}>
                {assistant.name}
              </option>
            ))}
          </FormSelect>
        </FormField>

        <FormField>
          <FormLabel htmlFor="whatsapp_id">Sessão WhatsApp</FormLabel>
          <FormSelect
            id="whatsapp_id"
            name="whatsapp_id"
            value={localFilters.whatsapp_id?.toString() || ''}
            onChange={e => handleLocalFilterChange('whatsapp_id', e.target.value)}
          >
            <option value="">Todas</option>
            {whatsappSessions.map(session => (
              <option key={session.id} value={session.id}>
                {session.session_name}
              </option>
            ))}
          </FormSelect>
        </FormField>
      </div>

      <div className="flex justify-end mt-4 space-x-2">
        {hasActiveFilters && (
          <Button variant="secondary" onClick={onResetFilters} className="flex items-center">
            <X className="h-4 w-4 mr-2" />
            Limpar Filtros
          </Button>
        )}
        <Button onClick={handleApplyFilters} className="flex items-center">
          <Search className="h-4 w-4 mr-2" />
          Filtrar
        </Button>
      </div>
    </div>
  );
}

export default FallbackRequestFilters;
